import { collectAllMeasures, getMutableComponentProps, removeMeasures } from "./utils";
export const setupContextObjective = (componentProps, allDependencies, originalComponentProps, argument) => {
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    const measures = collectAllMeasures(mutableComponentProps);
    const dependencyKey = (argument?.key ?? "objective");
    const objectiveValue = allDependencies[dependencyKey] ?? "none";
    const addToProjected = argument?.addToProjected === "true";
    for (const measure of measures) {
        const hasObjectivePlaceholder = Boolean(measure.context?.objective);
        const shouldAddToProjected = addToProjected && measure.context?.projectedOnly && objectiveValue !== "none";
        if (hasObjectivePlaceholder || shouldAddToProjected) {
            measure.context = { ...measure.context, objective: objectiveValue };
        }
    }
    removeMeasures(mutableComponentProps, (m) => m.context?.objective === "none");
    return mutableComponentProps;
};
